export default __webpack_public_path__ + "static/media/our-motivation.05272bc0.svg";